import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bbd3de5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sdds-nav__left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "sdds-nav__mob-menu-icon" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "sdds-nav__mob-menu-icon-line",
    id: "sdds-nav__mob-menu-icon-line-1"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "sdds-nav__mob-menu-icon-line",
    id: "sdds-nav__mob-menu-icon-line-2"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "sdds-nav__mob-menu-icon-line",
    id: "sdds-nav__mob-menu-icon-line-3"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  class: "sdds-nav__app-name",
  "data-test-id": "title"
}
const _hoisted_5 = { class: "sdds-nav__center" }
const _hoisted_6 = { class: "sdds-nav__inline-menu" }
const _hoisted_7 = { class: "sdds-nav__item-core-text" }
const _hoisted_8 = { class: "sdds-nav__toolbar-menu" }
const _hoisted_9 = { class: "sdds-nav__item sdds-nav__avatar" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sdds-nav__avatar-img",
  src: "https://www.svgrepo.com/show/170303/avatar.svg",
  alt: "profile photo"
}, null, -1))
const _hoisted_11 = { class: "sdds-nav__avatar-info sdds-nav__avatar-info--mobile" }
const _hoisted_12 = { class: "sdds-nav__avatar-title" }
const _hoisted_13 = { class: "sdds-nav__avatar-menu" }
const _hoisted_14 = { class: "sdds-nav__avatar-item sdds-nav__avatar-item--large" }
const _hoisted_15 = { class: "sdds-nav__avatar-info" }
const _hoisted_16 = { class: "sdds-nav__avatar-title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sdds-nav__right" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "sdds-nav__item sdds-nav__app-logo" })
], -1))

import { computed, ref, inject } from 'vue'
import { useRoute } from 'vue-router'
import { MenuItem } from '../types/component'
import { useMainStore } from '../store/index';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'TheSddsHeader',
  props: {
    title: null,
    menuItems: null
  },
  setup(__props: any) {

const props = __props as {
  title: string,
  menuItems: MenuItem[]
}



const route = useRoute();
const path = computed(() => route.name);
const userMenuOpen = ref(false);
const mobileMenuOpen = ref(false);
const keycloak = inject('keycloak');
const nameUser = useMainStore()?.name;

const toggleAvatarMenu = () => {
  userMenuOpen.value = !userMenuOpen.value;
};

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value;
};

const closeMenuFromOverlay = () => {
  mobileMenuOpen.value = false;
};

const logout = () => {
  console.log('logout');
  const logoutOptions = { redirectUri: window.location.origin };
  keycloak.logout(logoutOptions).then((success) => {
    console.log('--> log: logout success ', success);
  }).catch((error) => {
    console.log('--> log: logout error ', error);
  }).finally(() => {
    return false;
  });
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["sdds-nav", { 'sdds-nav__avatar--opened': userMenuOpen.value, 'sdds-nav__mob-menu--opened': mobileMenuOpen.value }]),
    "data-test-id": "sdds-menu"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "sdds-nav__overlay",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (closeMenuFromOverlay()))
      }),
      _createElementVNode("button", {
        class: "sdds-nav__mob-menu-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleMobileMenu()))
      }, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.name,
            class: _normalizeClass(["sdds-nav__item", { 'sdds-nav__item--active': _unref(path) === item.name }])
          }, [
            _createVNode(_component_router_link, {
              class: "sdds-nav__item-core",
              to: { name: item.name },
              "data-test-id": "menuOpcion"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(item.text), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ], 2))
        }), 128))
      ]),
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", _hoisted_9, [
          _createElementVNode("button", {
            class: "sdds-nav__avatar-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleAvatarMenu())),
            "data-test-id": "menuAvatar"
          }, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(nameUser)), 1)
            ])
          ]),
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("li", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(nameUser)), 1)
              ])
            ]),
            _createElementVNode("li", { class: "sdds-nav__avatar-item" }, [
              _createElementVNode("a", {
                class: "sdds-nav__avatar-item-core",
                onClick: logout,
                "data-test-id": "logout"
              }, "Logout")
            ])
          ])
        ])
      ])
    ]),
    _hoisted_17
  ], 2))
}
}

})